import styled from "styled-components";
import { MediaQueries } from "ratel-ui";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  padding: 56px 56px 48px;
  background: #0e8a3e;
  border-radius: 24px;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  word-break: break-word;

  ${MediaQueries.mobileTablet`
    padding: 40px 24px 32px;
    gap: 20px;
  `}

  ${MediaQueries.mobile`
    padding: 32px 20px 28px;
    gap: 20px;
    border-radius: 20px;
  `}
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background: #f7d518;
  border-radius: 999px;
  white-space: nowrap;
`;

export const BadgeCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: #0a0a0a;
  border-radius: 999px;
  color: #f7d518;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
  line-height: 1;
`;

export const BadgeText = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 14px;
  letter-spacing: 1.4px;
  color: #0a0a0a;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 44px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;

  ${MediaQueries.mobileTablet`
    font-size: 34px;
  `}

  ${MediaQueries.mobile`
    font-size: 26px;
  `}
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  white-space: pre-wrap;

  ${MediaQueries.mobile`
    font-size: 15px;
  `}
`;

export const CounterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 32px 48px;
  background: #05461e;
  border-radius: 20px;
  overflow: hidden;

  ${MediaQueries.mobile`
    padding: 20px 16px;
    gap: 12px;
    width: 100%;
  `}
`;

export const CounterLabel = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 13px;
  letter-spacing: 2.2px;
  color: #f7d518;
  white-space: nowrap;

  ${MediaQueries.mobile`
    font-size: 11px;
    letter-spacing: 1.8px;
  `}
`;

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  overflow: hidden;

  ${MediaQueries.mobile`
    gap: 6px;
  `}
`;

export const CounterCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px 24px 14px;
  background: rgba(10, 10, 10, 0.4);
  border-radius: 14px;

  ${MediaQueries.mobileTablet`
    padding: 14px 16px 12px;
    border-radius: 12px;
  `}

  ${MediaQueries.mobile`
    padding: 10px 8px 8px;
    border-radius: 10px;
    min-width: 52px;
  `}
`;

export const CounterValue = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 72px;
  line-height: 1;
  color: #ffffff;

  ${MediaQueries.mobileTablet`
    font-size: 52px;
  `}

  ${MediaQueries.mobile`
    font-size: 32px;
  `}
`;

export const CounterUnit = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
  letter-spacing: 1.6px;
  color: #f7d518;

  ${MediaQueries.mobile`
    font-size: 9px;
    letter-spacing: 1.2px;
  `}
`;

export const CounterSeparator = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 56px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.5);

  ${MediaQueries.mobileTablet`
    font-size: 40px;
  `}

  ${MediaQueries.mobile`
    font-size: 22px;
  `}
`;

export const Notice = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  max-width: 100%;
`;

export const NoticeIcon = styled.span`
  font-size: 16px;
  line-height: 1;
`;

export const NoticeText = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);

  ${MediaQueries.mobile`
    font-size: 13px;
  `}
`;

export const WhatsAppSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  width: 100%;
`;

export const WhatsAppButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 15px 18px;
  background: #1b229f;
  border-radius: 12px;
  color: #ffffff;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: #151a85;
    transform: translateY(-1px);
  }

  ${MediaQueries.mobile`
    font-size: 14px;
    white-space: normal;
    width: 100%;
  `}
`;

export const WhatsAppHint = styled.p`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
  text-align: center;

  ${MediaQueries.mobile`
    font-size: 13px;
  `}
`;
